import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Account.AccessToken.IRequest;
type Response = Api.Core.Account.AccessToken.IResponse;
type Headers = Api.Core.Account.AccessToken.IHeaders;
const apiAccountAccessTokenPath = '/api/Account/AccessToken';
export default async function accountAccessTokenApi(request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: apiAccountAccessTokenPath,
    method: HttpMethod.get,
    headers: getDefaultHeaders(),
  });
}
